// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  justify-items: center;
  transition: background-color 1s ease-out 0.25s;
}

.rain-overcast {
  background-color: rgb(58, 63, 90); /* azul gris muy oscuro */
}

.overcast {
  background-color: rgb(96, 103, 140); /* gris azulado */
}

.rain-partially-cloudy {
  background-color: rgb(120, 140, 170); /* azul lluvia */
}

.partially-cloudy {
  background-color: rgb(135, 180, 220); /* azul cielo suave */
}

.clear {
  background-color: rgb(255, 215, 120); /* amarillo sol */
}

.day-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

#today-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#today-image {
  max-width: 70px;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iCAAiC,EAAE,yBAAyB;AAC9D;;AAEA;EACE,mCAAmC,EAAE,iBAAiB;AACxD;;AAEA;EACE,oCAAoC,EAAE,gBAAgB;AACxD;;AAEA;EACE,oCAAoC,EAAE,qBAAqB;AAC7D;;AAEA;EACE,oCAAoC,EAAE,iBAAiB;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["body {\n  justify-items: center;\n  transition: background-color 1s ease-out 0.25s;\n}\n\n.rain-overcast {\n  background-color: rgb(58, 63, 90); /* azul gris muy oscuro */\n}\n\n.overcast {\n  background-color: rgb(96, 103, 140); /* gris azulado */\n}\n\n.rain-partially-cloudy {\n  background-color: rgb(120, 140, 170); /* azul lluvia */\n}\n\n.partially-cloudy {\n  background-color: rgb(135, 180, 220); /* azul cielo suave */\n}\n\n.clear {\n  background-color: rgb(255, 215, 120); /* amarillo sol */\n}\n\n.day-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n#today-data-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n#today-image {\n  max-width: 70px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
